import React, { useState } from 'react'
import { SearchMessageType } from '../types'
import { useListMessageAppearances } from '../hooks/useListMessageAppearances'
import {
  Box,
  Card,
  CircularProgress,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { TruncatedId } from '../../truncated-id'
import { FormattedDateTime } from '../../formatted-date-time'
import { ListMessageAppearancesV2_listSearchMessages_searchMessages_FavoriteV2 } from '../hooks/__generated__/ListMessageAppearancesV2'
import { Link as RouterLink } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller'
import { Spacer } from '@vestaboard/installables'

interface IListMessageAppearancesProps {
  messageId: string
}

const LIMIT = 50

export const ListMessageFavorites = (props: IListMessageAppearancesProps) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const { data, loading, error, fetchMore } = useListMessageAppearances({
    input: {
      types: [SearchMessageType.Favorite],
      allUsers: true,
      messageId: props.messageId,
      cursor: null,
      limit: LIMIT
    }
  })

  const appearances = (data?.listSearchMessages.searchMessages.filter(
    searchMessage => searchMessage.__typename === 'FavoriteV2'
  ) || []) as ListMessageAppearancesV2_listSearchMessages_searchMessages_FavoriteV2[]

  return loading ? (
    <CircularProgress />
  ) : error ? (
    <Alert severity='error'>There was an error loading the favorited messages</Alert>
  ) : !appearances?.length ? (
    <Alert severity='info'>There are no favorites for this message</Alert>
  ) : (
    <Card>
      <InfiniteScroll
        pageStart={0}
        loadMore={async () => {
          if (isLoadingMore) {
            return
          }

          setIsLoadingMore(true)

          return await fetchMore({
            updateQuery(previousQueryResult, options) {
              const newMessageSets = options.fetchMoreResult?.listSearchMessages?.searchMessages || []
              const previousMessageSets = previousQueryResult?.listSearchMessages?.searchMessages || []

              return {
                listSearchMessages: {
                  ...previousQueryResult.listSearchMessages,
                  nextCursor: options.fetchMoreResult?.listSearchMessages.nextCursor || null,
                  searchMessages: [...previousMessageSets, ...newMessageSets]
                }
              }
            },
            variables: {
              input: {
                types: [SearchMessageType.Favorite],
                allUsers: true,
                messageId: props.messageId,
                cursor: data?.listSearchMessages.nextCursor || null,
                limit: LIMIT
              }
            }
          }).then(res => {
            setIsLoadingMore(false)
            return res
          })
        }}
        hasMore={!!data?.listSearchMessages?.nextCursor}
        loader={
          <Box>
            <Spacer size='large' />
            <CircularProgress />
          </Box>
        }>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Attribution</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {appearances.map(feedItem => (
                <TableRow key={feedItem.id}>
                  <TableCell>
                    <TruncatedId value={feedItem.id} full />
                  </TableCell>
                  <TableCell>
                    <FormattedDateTime value={new Date(feedItem.created).getTime()} />
                  </TableCell>
                  <TableCell>
                    <Link component={RouterLink} to={`/person/${feedItem.favoritePersonId}`}>
                      {feedItem.attribution}
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>
    </Card>
  )
}
